import { useEffect } from 'react';

const useDocumentTitle = (title: string) => {
  useEffect(() => {
    document.title = `ASTRAD | ${title}`;
  }, [title]);
};

export default useDocumentTitle;
